import {
    initiatialForumCategoriesPageState,
    ForumCategoriesPageState,
} from 'mk2/apps/forum/containers/ForumCategories/ForumCategories.reducers';
import { AppState } from 'mk2/reducers';

export const getForumCategoriesPageState = (state: AppState): ForumCategoriesPageState =>
    state.containers.forum.forumCategories || initiatialForumCategoriesPageState;
